import { render } from "./cookeis.vue?vue&type=template&id=b336ba68&scoped=true"
import script from "./cookeis.vue?vue&type=script&lang=js"
export * from "./cookeis.vue?vue&type=script&lang=js"

import "./cookeis.vue?vue&type=style&index=0&id=b336ba68&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b336ba68"]])

export default __exports__